import {
    getEzvizInfo,
    setEzvizInfo,
    removeEzvizInfo
} from "../../utils/auth";
import axios from 'axios';

const state = {
    ezvizInfo: getEzvizInfo(),
    tokenTimer: null,
    isInitializing: false
};

const getters = {
    ezvizToken: state => {
        const info = state.ezvizInfo;
        if (!info || !info.timestamp || Date.now() > info.timestamp) {
            return null;
        }
        return info.token;
    }
};

const mutations = {
    SET_EZVIZ_INFO(state, ezvizInfo) {
        state.ezvizInfo = ezvizInfo;
    },
    SET_TOKEN_TIMER(state, timer) {
        if (state.tokenTimer) {
            clearTimeout(state.tokenTimer);
        }
        state.tokenTimer = timer;
    },
    SET_INITIALIZING(state, status) {
        state.isInitializing = status;
    }
};

const actions = {
    setEzvizInfo({commit}, {token, expireTime}) {
        const timestamp = expireTime - Date.now();
        commit("SET_EZVIZ_INFO", {token, expireTime});
        setEzvizInfo(token, expireTime);
        
        // 设置定时器，在token过期时更新token
        const timer = setTimeout(() => {
            this.dispatch('ezviz/updateToken');
        }, timestamp);
        commit("SET_TOKEN_TIMER", timer);
    },

    async updateToken({dispatch, state}) {
        try {
            const params = new URLSearchParams();
            params.append('appKey', "c19262048d434baeb6f5a117b84f0000");
            params.append('appSecret', "f36161f53cdb8ecc9835b713ca3abc09");
                    
            let response = await axios.post('https://open.ys7.com/api/lapp/token/get', params, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

            if (response.data && response.data.data) {
                console.log(response);
                const { accessToken, expireTime } = response.data.data;
                dispatch('setEzvizInfo', {
                    token: accessToken,
                    expireTime: expireTime
                });
            }
        } catch (error) {
            console.error('更新萤石云token失败:', error);
        }
    },

    initEzvizToken({state, commit, dispatch}) {
        console.log('initEzvizToken被调用', new Error().stack);
        // 如果正在初始化，直接返回
        if (state.isInitializing) {
            return;
        }
        // 设置初始化状态
        commit("SET_INITIALIZING", true);

        const info = state.ezvizInfo;
        if (!info || !info.timestamp || Date.now() > info.timestamp) {
            // token不存在或已过期，立即获取
            dispatch('updateToken').finally(() => {
                commit("SET_INITIALIZING", false);
            });
        } else {
            // token未过期，设置定时器
            const updateTime = info.timestamp - Date.now();
            const timer = setTimeout(() => {
                dispatch('updateToken');
            }, updateTime);
            commit("SET_TOKEN_TIMER", timer);
            commit("SET_INITIALIZING", false);
        }
    },

    clearEzvizInfo({commit}) {
        commit("SET_EZVIZ_INFO", null);
        commit("SET_TOKEN_TIMER", null);
        removeEzvizInfo();
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}; 